import React from 'react';
import { useState, useEffect, useMemo } from 'react';
import MainContainer from '../../../components/MainContainer';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Table, Alert, Chip, Autocomplete, IconButton, Tabs, Tab, Skeleton } from '@mui/material';
import { headerDataMission } from '../../../data/modules/mission-header';
import { colors, Grid, makeStyles } from '@material-ui/core';
import MissionSummaryService from '../../../services/MissionSummaryService';
import { useLocation, useNavigate, useParams } from 'react-router';
import Message from '../../tools/Message';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import AddIcon from '@mui/icons-material/Add';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import CloseIcon from '@mui/icons-material/Close';
import { TabContext, TabPanel } from '@mui/lab';
import DestinationAddDialog from './DestinationAddDialog';
import DestinationViewDialog from './DestinationViewDialog';
import RemoveDestinationDialog from './RemoveDestinationDialog';
import { validateTimesheetForm } from '../../../helpers/ValidateForm';
import MissionData from './MissionData';
import RentManagement from './RentManagement';
import { formatDate } from '../../../helpers/FormateDate';
import TimesheetSend from './TimesheetSend';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
import CarRentalIcon from '@mui/icons-material/CarRental';
import MissionRentService from '../../../services/MissionRentService';
import SendIcon from '@mui/icons-material/Send';
import EditIcon from '@mui/icons-material/Edit';
import Bullred from '../../../components/reusable/Bullred';
import formatWithThousandSeparator from '../../../helpers/FormatWithThousandSeparator';
import { stickyHeaderCellSx, stickySubHeaderCellSx } from '../../../styles/TableStyle.style';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
  distributeNightNumbers,
  getNightDateKey,
  getNightDistributionMeta,
  normalizeNightInputValue,
  normalizeNightNumber,
  countNightsMission
} from '../../../helpers/TimesheetNightHelper';
import { obtenirIndicesMontantsJournaliersMasques } from '../../../helpers/TimesheetRentHelper';

const LOCATION_FIELDS = {
  depart: {
    region: 'region_depart',
    district: 'district_depart',
    commune: 'commune_depart',
    fokontany: 'fokontany_depart',
  },
  arrivee: {
    region: 'region_arrivee',
    district: 'district_arrivee',
    commune: 'commune_arrivee',
    fokontany: 'fokontany_arrivee',
  },
};

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    fontSize: "12px",
    borderRadius: "8px !important",
    marginLeft: "1%",
     maxWidth: "95vw",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
  },
  tab: {
    width: "50%",
    color: "#1976d2",
    fontSize: "24px",
    fontWeight: "bold",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  fieldset: {
     borderRadius: "10px",
    color: "#1976d2",
    fontSize: "20px",
    marginTop: "10px",
    overflowX: "auto",
    padding: "10px",
    maxWidth: "96vw",
    width: "100%",
    // boxShadow: "rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;!important",
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    border: "1px solid #d7e1f3",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
  },
  dialog: {
    width: "99%",
    height: "99%",
    justifyContent: "center",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "20px",
    fontSize: "12px",
  },
  tdBordered: {
    textAlign: "center",
   borderLeft: "1px solid #c8c8c8ff",
  },
   tdBorderedRight: {
    textAlign: "center",
   borderRight: "1px solid #c8c8c8ff",
  }
}));

const TimesheetAdd = () => {
  const { mission_planning_id, timesheet_id, agenda_id } = useParams();
  const currentTimesheetId = Number(timesheet_id) > 0
    ? Number(timesheet_id)
    : null;
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const [mission, setMission] = useState(null);
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [loadingDestinations, setLoadingDestinations] = useState(false);
  const [timesheet, setTimesheet] = useState(null);
  const [agendas, setAgendas] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [value, setValue] = useState('1');
  const [missionnaries, setMissionnaries] = useState([]);
  const [message, setMessage] = useState({
      open: false,
      color: 'green',
      messageInfo: '',
    });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    mission_planning_id: mission_planning_id || null,
    agenda_id: agenda_id || null,
    timesheet_id: currentTimesheetId,
  });
  const [transportMeans, setTransportMeans] = useState( [
    { label: 'Voiture FID', value: 'FID', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
    { label: 'Avion', value: 'AVION', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
    { label: 'Bateau', value: 'BATEAU', mission_rent_id: null, rent_upfuel: null, rent_amount: null, rent_paiement: null, rent_conso_100km: null },
  ]);
  const [destDialog, setDestDialog] = useState({ open: false, agenda_id: null, mission_timesheet_id: null, onClose: () => setDestDialog({ ...destDialog, open: false, agenda_id: null, mission_timesheet_id: null }), missionnaries: [] });
  const [removeDialog, setRemoveDialog] = useState({ open: false, agenda_id: null, mission_destination_id: null, mission_timesheet_destination_id: null, rowIndex: null, onClose: () => setRemoveDialog({ ...removeDialog, open: false, agenda_id: null, mission_destination_id: null, mission_timesheet_destination_id: null, rowIndex: null }) });
  const [viewDialog, setViewDialog] = useState({ open: false, destination: null, index: null, editable: false });
 const { open, color, messageInfo } = message;
    function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const isLoadingData = loadingDestinations;

  const fetchMission = async () => {
    try {
      setLoadingBackdrop(true);
      const response = await MissionSummaryService.getMissionData(mission_planning_id, agenda_id);
      if(response && response.status){
        setMission(response.data);
        setAgendas(response.data.agendas || []);
        setMissionnaries(response.data.missionnaries || []);
      }
    }
    catch (error) {
      console.error("Error fetching mission data:", error);
    }
    finally {
      setLoadingBackdrop(false);
    }
  };

  const getTimesheetData = async () => {
        try{
            const result = await TimeSheetMissionService.getTimesheetData(currentTimesheetId);
            if(result && result.status){
              setTimesheet(result.data);
            }
        } catch (error){
            console.error("Error fetching timesheet data:", error);
        }
  };

 useEffect(() => { // fetch timesheet data if timesheet_id is provided
    if (currentTimesheetId) {
      getTimesheetData();
    }
  }, [currentTimesheetId]);

  const applyFinancementFromNextDM = (destinations, index) => {
    for (let i = index + 1; i < destinations.length; i++) {
      const nextDest = destinations[i];
      if (nextDest.code_financement_mis && nextDest.id_financement_mis) {
        return {
          code_financement_mis: nextDest.code_financement_mis,
          id_financement_mis: nextDest.id_financement_mis
        };
      }
    }
    return {
      code_financement_mis: null,
      id_financement_mis: null
    };
  };

  const fetchDestinations = async () => {
    setLoadingBackdrop(true);
    setLoadingDestinations(true);
    try {
      const response = await TimeSheetMissionService.retrieveDestinationsTimesheet(
        mission_planning_id,
        agenda_id,
        currentTimesheetId
      );
      if (!response?.status) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: response?.message || 'Erreur de récupération des destinations.',
        });
        return;
      }

      const expectedSource = currentTimesheetId === null ? 'agenda' : 'timesheet';
      if (response.source && response.source !== expectedSource) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: 'La source des destinations reçues ne correspond pas à la timesheet courante.',
        });
        return;
      }

      const destinationsResult = Array.isArray(response.data) ? response.data : [];
      const mappedDestinations = destinationsResult.map((dest, index) => {
        const financement = applyFinancementFromNextDM(destinationsResult, index);
        const hasSavedNightNumber =
          dest.night_number !== undefined && dest.night_number !== null;
        return {
          index,
          ...dest,
          transport_type: dest.mission_rent_id
            ? dest.rent_type
            : (dest.transport_type || 'FID'),
          code_financement_mis:
            dest.code_financement_mis || financement.code_financement_mis || '',
          id_financement_mis:
            dest.id_financement_mis || financement.id_financement_mis || null,
          night_number:
            hasSavedNightNumber
              ? dest.night_number
              : (index === destinationsResult.length - 1
                  ? 0
                  : countNightsMission(
                      index > 0 ? destinationsResult[index - 1].date_end : null,
                      dest.date_begin,
                      dest.date_end
                    )),
          _nightNumberSource: hasSavedNightNumber ? 'saved' : 'automatic',
        };
      });
      setDestinations(distributeNightNumbers(mappedDestinations));
    } catch (error) {
      console.error('Error fetching destinations:', error);
      setMessage({
        open: true,
        color: 'red',
        messageInfo: error.message || 'Erreur de récupération des destinations.',
      });
    } finally {
      setLoadingDestinations(false);
      setLoadingBackdrop(false);
    }
  };

  useEffect(() => { // fetch mission data
    fetchMission();
  }, [mission_planning_id]);

  useEffect(() => { // fetch destinations data
    fetchDestinations();
    fetchTransportMeans();

  }, [mission_planning_id, agenda_id, currentTimesheetId]);

const handleChangeKm = (e, index) => {
  const { value } = e.target;
  setDestinations((prev) => {
    const updated = [...prev];
    const current = { ...(updated[index] || {}) };
    const rent = current.mission_rent_id ? transportMeans.find(t => t.mission_rent_id === current.mission_rent_id) : null;
    const conso100km = rent?.rent_conso_100km || 0;
    const rentupfuel = rent?.rent_upfuel || 0;

    current.distance_km = value;
    if (rent) {
      current.mission_timesheet_details_consumption = conso100km ? (value / conso100km) || 0 : 0;
      current.mission_timesheet_details_amount = current.mission_timesheet_details_consumption * rentupfuel || 0;
    }
    updated[index] = current;
    return updated;
  });
};

const handleOpenDestDialog = (agenda_id, mission_timesheet_id) => {
    setDestDialog({
      open: true,
      agenda_id: agenda_id,
      mission_timesheet_id : mission_timesheet_id,
      onClose: () => setDestDialog({ ...destDialog, open: false, agenda_id: null, mission_timesheet_id: null }),
      missionnaries: missionnaries
    });
  }

   const fetchTransportMeans = async () => { // récuperer les differents moyns de transport
          try {
              const result = await MissionRentService.getRentsByAgendaId(agenda_id);
              if(!result || !result.status) {
                  console.error("Error fetching transport:", result ? result.message : 'Unknown error');
                  return;
              }
            const rentsResult = result.data;
              setTransportMeans(prev => {
                const transportOptions = rentsResult.map(rent => ({
                  label: rent.rent_type,
                  value: rent.rent_type,
                  mission_rent_id: rent.mission_rent_id,
                  rent_upfuel: rent.rent_upfuel,
                  rent_amount: rent.rent_amount,
                  rent_paiement: rent.rent_paiement,
                  rent_conso_100km: rent.rent_conso_100km,
                }));
                return [  ...prev, ...transportOptions ];
            });

          } catch (error) {
              console.error("Error fetching transport:", error);
          }
  };
  const handleChangeFormValues = (field, value, index) => {
    if(field === 'transport_type') {
      const transport_value = value?.value ?? ''; // Extract the value from the selected option
      const mission_rent_id = value?.mission_rent_id || null;

      setDestinations((prev) => {
        const updated = [...prev];
        const currentEntry = { ...(updated[index] || {}) };
        const currentKm = Number(currentEntry.distance_km) || 0;
        const rentDetails = mission_rent_id ? transportMeans.find(t => t.mission_rent_id === mission_rent_id) : null;
        const rentConso = rentDetails?.rent_conso_100km || 0;
        const rentUpFuel = rentDetails?.rent_upfuel || 0;
        const mission_timesheet_details_consumption = mission_rent_id && rentConso ? currentKm / rentConso : 0;
        const mission_timesheet_details_amount = mission_rent_id ? mission_timesheet_details_consumption * rentUpFuel : 0;

        updated[index] = {
          ...currentEntry,
          mission_rent_id: mission_rent_id,
          [field]: transport_value,
          mission_timesheet_details_consumption,
          mission_timesheet_details_amount,
        };
        return updated;
      });
      return;
    }

    setDestinations((prev) => {
      const updated = [...prev];
      const currentEntry = { ...(updated[index] || {}) };
      currentEntry[field] = value;

      if (currentEntry.mission_rent_id !== null && currentEntry.mission_rent_id !== undefined) {
        const rent_upfuel = transportMeans.find(t => t.mission_rent_id === currentEntry.mission_rent_id)?.rent_upfuel || 0;
        if (field === 'mission_timesheet_details_consumption') {
          currentEntry.mission_timesheet_details_amount =  rent_upfuel * value;
        } else if (field === 'mission_timesheet_details_amount') {
          currentEntry.mission_timesheet_details_consumption = rent_upfuel ? value / rent_upfuel : 0;
        }
      }
      updated[index] = currentEntry;
      return updated;
    });
  };

  const getLocationFieldKey = (type, level) => LOCATION_FIELDS[type][level];

  const isNewTimesheet = (value) => value === null || value === undefined || String(value) === '0';

  const buildTimesheetRequest = (destinationRows, targetTimesheetId = currentTimesheetId) => {
    const normalizedRows = distributeNightNumbers(destinationRows);

    return {
      mission_planning_id: mission?.mission_planning_id || mission_planning_id || null,
      mission_timesheet_id: targetTimesheetId || null,
      mission_planning_agenda_id: agenda_id || null,
      action: isNewTimesheet(targetTimesheetId) ? 'create' : 'update',
      timesheet_destinations: normalizedRows.map(item => ({
      mission_destination_id: item.mission_destination_id || null,
      mission_timesheet_destination_id: item.mission_timesheet_destination_id || null,
      mission_planning_agenda_id: agenda_id || null,
      observation: item.observation,
      date_begin: item.date_begin,
      date_end: item.date_end,
      heure_begin: item.heure_begin,
      type: item.type,
      activite: item.activite,
      code_financement_mis: item.code_financement_mis || '',
      id_financement_mis: item.id_financement_mis || null,
      heure_end: item.heure_end,
      transport_id: item.transport_id || null,
      transport_type: item.transport_type,
      distance_km: item.distance_km || 0,
      mission_timesheet_fuel_id: item.mission_timesheet_fuel_id || null,
      region_depart: item.region_depart || '',
      district_depart: item.district_depart || '',
      commune_depart: item.commune_depart || '',
      fokontany_depart: item.fokontany_depart || '',
      region_arrivee: item.region_arrivee || '',
      district_arrivee: item.district_arrivee || '',
      commune_arrivee: item.commune_arrivee || '',
      fokontany_arrivee: item.fokontany_arrivee || '',
      mission_rent_id: item.mission_rent_id || null,
      night_number: item.night_number ?? 0,
      missionnaries: item.missionnaries
        ? item.missionnaries.map(m => ({
            missionary_id: m.missionary_id || m.user_id,
            missionary_timesheet_mobility_id: m.missionary_timesheet_mobility_id || m.missionary_timesheet_mobility || null,
          }))
        : [],
      fuels: item.mission_rent_id ? [{
        fuel_consumption: item.mission_timesheet_details_consumption || 0,
        fuel_amount: item.mission_timesheet_details_amount || 0,
      }] : [],
      })),
    };
  };

  const handleAddDestination = async (newDestination) => {
    const selectedMissionaryIds = (newDestination.missionnaries || []).map(
      (missionnary) => missionnary?.missionary_id
        ?? missionnary?.user_id
        ?? missionnary
    );
    const draftDestination = {
      ...newDestination,
      mission_timesheet_id: null,
      mission_timesheet_destination_id: null,
      distance_km: newDestination.distance_km ?? null,
      night_number: newDestination.night_number || 0,
      _nightNumberSource: 'automatic',
      missionnaries: missionnaries.filter((missionary) =>
        selectedMissionaryIds.some(
          (id) => String(id) === String(missionary.user_id)
        )
      ),
    };
    const draftDestinations = [...destinations, draftDestination];
    const dataToSend = buildTimesheetRequest(draftDestinations, null);
    const validation = validateTimesheetForm(dataToSend);

    if (!validation.valid) {
      setMessage({ open: true, color: 'red', messageInfo: validation.message });
      return false;
    }

    if (!/\/0\/?$/.test(location.pathname)) {
      setMessage({
        open: true,
        color: 'red',
        messageInfo: 'Impossible de déterminer l’adresse du nouveau brouillon.',
      });
      return false;
    }

    setLoadingBackdrop(true);
    setDisabled(true);
    try {
      const result = await TimeSheetMissionService.saveTimesheetMission(dataToSend);
      const newTimesheetId = Number(result?.data?.mission_timesheet_id);

      if (!result?.status || !Number.isInteger(newTimesheetId) || newTimesheetId <= 0) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: result?.message || 'Erreur lors de la création du brouillon.',
        });
        return false;
      }

      const nextPath = location.pathname.replace(/\/0\/?$/, `/${newTimesheetId}`);
      setMessage({
        open: true,
        color: 'green',
        messageInfo: 'Destination ajoutée et brouillon enregistré avec succès.',
      });
      navigate(
        { pathname: nextPath, search: location.search },
        { replace: true }
      );
      return true;
    } catch (error) {
      setMessage({
        open: true,
        color: 'red',
        messageInfo: error.message || 'Erreur lors de la création du brouillon.',
      });
      return false;
    } finally {
      setLoadingBackdrop(false);
      setDisabled(false);
    }
  };

  const handleSave = async (action) => {
    setLoadingBackdrop(true);
    setDisabled(true);

    try {
      const timesheetMeta = {
          mission_planning_id: mission.mission_planning_id || null,
      mission_timesheet_id: currentTimesheetId,
      mission_planning_agenda_id: agenda_id || null,
      action: currentTimesheetId === null ? 'create' : 'update',
      }
    const validationPayload = {...timesheetMeta, timesheet_destinations: destinations };
    const IsValid = validateTimesheetForm(validationPayload);

    if (!IsValid.valid) {
        setMessage({ open: true, color: 'red', messageInfo: IsValid.message });
        setDisabled(false);
        return;
    }

    const dataTosend = buildTimesheetRequest(destinations);

    const result = await TimeSheetMissionService.saveTimesheetMission(dataTosend);
    if(result && result.status){
      if(action === 'save'){
      setMessage({ open: true, color: 'green', messageInfo: 'La Timesheet a été enregistrée avec succès.' });
      navigate('/mission/timesheet');
      }
      if(action === 'send'){
          setMessage({ open: true, color: 'green', messageInfo: 'La feuille de temps a été enregistrée et envoyée avec succès.' });
          setConfirmDialog({
            open: true,
            mission_planning_id: mission_planning_id || null,
            agenda_id: agenda_id || null,
            timesheet_id: result.data.mission_timesheet_id || null,
          });
      }
    } else {
      setMessage({ open: true, color: 'red', messageInfo: result.message || 'Une erreur est survenue lors de l\'enregistrement de la feuille de temps.' });
      setDisabled(false);
    }

    } catch (error) {
      setMessage({ open: true, color: 'red', messageInfo: error.message });
    }
    finally {
      setLoadingBackdrop(false);
      setDisabled(false);
    }
  };

  const handleOpenDestinationView = (destination, index = null, editable = false) => {
    if (!destination) {
      return;
    }
    setViewDialog({ open: true, destination, index, editable });
  };

  const handleCloseDestinationView = () => {
    setViewDialog({ open: false, destination: null, index: null, editable: false });
  };

  const handleSaveDestinationEdit = (updatedFields) => {
    if (viewDialog.index === null) {
      handleCloseDestinationView();
      return;
    }
    const keys = [
      'region_depart', 'district_depart', 'commune_depart', 'fokontany_depart',
      'region_arrivee', 'district_arrivee', 'commune_arrivee', 'fokontany_arrivee',
      'lieu_depart', 'lieu_arrivee', 'heure_begin', 'heure_end'
    ];
    setDestinations((prev) => {
      const updated = [...prev];
      const currentEntry = { ...(updated[viewDialog.index] || {}) };
      keys.forEach((key) => {
        if (updatedFields[key] !== undefined) {
          currentEntry[key] = updatedFields[key] || '';
        }
      });
      updated[viewDialog.index] = currentEntry;
      return distributeNightNumbers(updated);
    });
    handleCloseDestinationView();
  };

  const getLocationLabel = (entry, destination, type, level) => {
    const key = getLocationFieldKey(type, level);
    return entry?.[key] || destination?.[key] || '-';
  };

  const locationsParId = useMemo(
    () => new Map(
      transportMeans
        .filter((moyen) => moyen?.mission_rent_id !== null && moyen?.mission_rent_id !== undefined)
        .map((moyen) => [String(moyen.mission_rent_id), moyen])
    ),
    [transportMeans]
  );

  const rentOccurrencesById = destinations.reduce((acc, destination) => {
    const rentId = destination?.mission_rent_id;
    if (rentId === null || rentId === undefined) {
      return acc;
    }

    acc[rentId] = (acc[rentId] || 0) + 1;
    return acc;
  }, {});

  const indicesMontantsJournaliersMasques = useMemo(
    () => obtenirIndicesMontantsJournaliersMasques(
      destinations,
      (destination) => locationsParId.get(String(destination?.mission_rent_id)) || destination
    ),
    [destinations, locationsParId]
  );

  const nightDistributionMeta = getNightDistributionMeta(destinations);

  const handleChangeNightNumber = (value, index) => {
    setDestinations((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...(updated[index] || {}),
        night_number: normalizeNightInputValue(value),
        _nightNumberSource: 'manual',
      };
      return updated;
    });
  };

  const handleBlurNightNumber = (index) => {
    setDestinations((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...(updated[index] || {}),
        night_number: normalizeNightNumber(updated[index]?.night_number),
      };
      return distributeNightNumbers(updated);
    });
  };

  const setDestinationsWithNightDistribution = (updater) => {
    setDestinations((previousDestinations) => {
      const nextDestinations = typeof updater === 'function'
        ? updater(previousDestinations)
        : updater;
      return distributeNightNumbers(nextDestinations || []);
    });
  };

    return (
       <MainContainer {...headerDataMission}>
        <Message open={open} handleClose={handleCloseMessage} color={color} messageInfo={messageInfo} />
            <Dialog
            open={true}
            fullScreen
            aria-labelledby="form-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.dialog}
      >
        <DialogTitle id="form-dialog-title"><CalendarMonthIcon /><span> Elaboration de la timesheet - {mission?.reference} </span></DialogTitle>
        <DialogContent dividers>
        <DialogContentText  sx={{fontSize: '12px', color: '#8e9194ff'}}>
              <LoadingSimpleBackdrop openLoadingSimpleBackdrop={loadingBackdrop} />
                <MissionData mission={mission} />
                {timesheet && timesheet.mission_timesheet_state == "REFUSED" && (
                  <Alert severity='error' size='small' sx={{ fontSize: "12px", marginBottom: "10px" }}>
                    Cette timesheet a été refusée. Veuillez apporter les modifications nécessaires et la renvoyer.
                    <strong> Motif de refus : "{timesheet.observation}"</strong>
                  </Alert>)
                  }
                 <Alert severity="info" size="small" sx={{ fontSize: "12px", height: "40px", marginTop: "4px" }}>
                          Les modifications apportées aux lignes d’agenda <strong>(ajout ou retrait)</strong> n’affectent pas l’agenda affiché dans le TDR. Elles servent uniquement à optimiser la timesheet et le calcul du carburant.<br></br>
                      </Alert>
                      {
                        agendas.length !==0 ? (
                      agendas.map((agenda, index) => (
                 <fieldset className={classes.fieldset}>
                        <legend>
                          &nbsp;&nbsp;
                          {`Agenda ${ agendas?.length > 1 ? (agendas[index].mission_planning_destination_id	!= null ? 'mission ' + (index + 1) : (index + 1)) : ''} : ${agenda.reference}`}
                          &nbsp; &nbsp;
                        </legend>
                          <TabContext value={value}>

                      <TabPanel value="1">
                        <Grid container spacing={2} >
                         <Grid item xs={12} sm={12} md={12}>
                          <Button color='info' variant="contained" startIcon={<AddIcon />} size="small" onClick={() => handleOpenDestDialog(agenda.mission_planning_agenda_id, currentTimesheetId)}>
                            Ajouter une ligne
                          </Button>
                           <Button color='secondary' ml={2} variant="contained" sx={{marginLeft: "10px"}} startIcon={<CarRentalIcon />} size="small"
                           onClick={() => setValue('2')}
                          >
                            Gérer location
                          </Button>
                          </Grid>
                          </Grid>
                          {/* entete du tableau */}
                      <TableContainer sx={{maxWidth: "92vw", width: "100%", height: "580px", overflowX: "auto", overflowY: "auto"}}>
                          <Table>
                            <TableHead>
                              <TableRow sx={{ "& th": stickyHeaderCellSx }}>
                                    <TableCell rowSpan={2} sx={{ minWidth: '4px'}}></TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '100px', textAlign: "center" }}>Date(s)</TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '80px', textAlign: "center" }}>Heure départ</TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '80px', textAlign: "center" }}>Heure arrivée</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu de départ</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu d'arrivée</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '60px', textAlign: "center" }}>Type</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '150px', textAlign: "center" }}>Missionnaire(s)</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '130px', textAlign: "center" }}>Financement</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '130px', textAlign: "center" }}>Estimation Kilométrage</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '220px', textAlign: "center" }}>Moyen de transport <br/>souhaité <Bullred/></TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Consommation en l</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Estimation prix unitaire en Ar</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Carburant en Ar</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '120px', textAlign: "center" }}>Description montant en charge</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '100px', textAlign: "center" }}>Mode de paiement</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '100px', textAlign: "center" }}>Autre Montant en charge en Ar</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '100px', textAlign: "center" }}>Nombre de nuitées</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '500px', textAlign: "center" }}>Observation</TableCell>
                              </TableRow>
                              <TableRow sx={{ "& th": stickySubHeaderCellSx }}>
                                    <TableCell sx={{ minWidth: '70px'}} className={classes.tdBordered}>Région <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center"}}>Fokontany </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Lieu</TableCell>
                                    <TableCell sx={{ minWidth: '70px'}} className={classes.tdBordered}>Région <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Fokontany</TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }} className={classes.tdBorderedRight}>Lieu</TableCell>

                              </TableRow>
                            </TableHead>
                <TableBody  sx={{
                    "& .MuiTableCell-body": {
                      fontSize: "12px",
                    },
                  }}>
                    {isLoadingData ? (
                      Array.from({ length: 6 }).map((_, skeletonIndex) => (
                        <TableRow key={`skeleton-${skeletonIndex}`}>
                          {Array.from({ length: 27 }).map((__, cellIndex) => (
                            <TableCell key={`skeleton-cell-${skeletonIndex}-${cellIndex}`}>
                              <Skeleton variant="rectangular" height={24} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : (
                    destinations.map((dest, index) => {
                      const rowEntry = dest || {};
                      const rentDetails = dest?.mission_rent_id
                        ? locationsParId.get(String(dest.mission_rent_id))
                        : null;
                      const rentUpfuel = rentDetails?.rent_upfuel;
                      const rentAmount = rentDetails?.rent_amount;
                      const rentAmountToDisplay = indicesMontantsJournaliersMasques.has(index)
                        ? null
                        : rentAmount;
                      const rentDisplayName = rentDetails?.label || rentDetails?.value || dest?.transport_type || 'Location';
                      const rentPaymentMode = String(rentDetails?.rent_paiement || '').toLowerCase();
                      const isFlatRent = ['flat', 'forfait', 'forfaitaire'].includes(rentPaymentMode);
                      const repeatedRentCount = dest?.mission_rent_id ? (rentOccurrencesById[dest.mission_rent_id] || 0) : 0;
                      const isRepeatedFlatRent = isFlatRent && repeatedRentCount > 1; // verifier s'il s'agit d'un forfait répété
                      const rentPaymentLabel = dest?.mission_rent_id
                        ? (isRepeatedFlatRent ? 'Forfaitaire unique' : (isFlatRent ? 'Forfaitaire' : 'Paiement par jour'))
                        : null;
                      const nightDateKey = getNightDateKey(dest?.date_begin, index);
                      const nightGroup = nightDistributionMeta.groups.get(nightDateKey);
                      const canEditNightNumber = nightGroup?.lastIndex === index;
                      return (
                      <TableRow key={index}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "#ffffffdb",
                                },
                                "&:hover": {
                                  backgroundColor: "#f3f7fbeb",
                                },
                              }}>
                        <TableCell sx={{ minWidth: '4px'}} >
                          <IconButton aria-label="modifier la ligne" size="small" color="info" onClick={() => handleOpenDestinationView(dest, index, true)} sx={{backgroundColor: "#e6f7ff", borderRadius: "20px"}}>
                            <EditIcon fontSize="inherit"/>
                          </IconButton>
                            <IconButton aria-label="delete" size="small" color="error" sx={{backgroundColor: "#ffebe6"}}
                             onClick={() => setRemoveDialog({ open: true, agenda_id: agenda.mission_planning_agenda_id,
                            mission_destination_id: dest.mission_destination_id || null,
                             mission_timesheet_destination_id: dest.mission_timesheet_destination_id || null,
                             rowIndex: index })}
                             >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                          </TableCell>
                        <TableCell sx={{ maxWidth: '100px'}} className={classes.tdBordered}>{formatDate(dest.date_begin) == formatDate(dest.date_end) ? formatDate(dest.date_begin) : (formatDate(dest.date_begin) + " - " + formatDate(dest.date_end))}</TableCell>
                        <TableCell sx={{ maxWidth: '80px', textAlign: "center"}}>{dest.heure_begin}</TableCell>
                        <TableCell sx={{ maxWidth: '80px', textAlign: "center"}}>{dest.heure_end}</TableCell>
                        <TableCell sx={{ maxWidth: '120px', py: 0.5 }} className={classes.tdBordered}>
                        {getLocationLabel(rowEntry, dest, 'depart', 'region')}
                        </TableCell>
                        <TableCell sx={{ maxWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'district')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'commune')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'depart', 'fokontany')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>{dest.lieu_depart || dest.direction_location || '-'}</TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }} className={classes.tdBordered}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'region')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'district')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'commune')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', py: 0.5 }}>
                          {getLocationLabel(rowEntry, dest, 'arrivee', 'fokontany')}
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px', textAlign: "center" }}>{dest.lieu_arrivee || dest.direction_location || '-'}</TableCell>
                        <TableCell className={classes.tdBordered}>{dest.type === "DM" ? <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" /> : <Chip icon={<TimeToLeaveIcon />} style={{ fontSize: "12px" }} label="Délai de route" variant="outlined"/>}</TableCell>
                       <TableCell sx={{ minWidth: '150px', textAlign: "center"}}>
                        {dest.missionnaries && dest.missionnaries.length > 0 ? (
                          dest.missionnaries.map((m, i) => (
                            <li key={i}>
                              {m.name}
                            </li>
                          ))
                        ) :
                        missionnaries.length > 0 ? (
                          missionnaries.map((m, i) => (
                            <li key={i}>
                              {m.name}
                            </li>
                          ))
                        ) : (
                          null
                        )}
                        </TableCell>
                       <TableCell sx={{minWidth: '130px'}}>
                        { dest?.code_financement_mis ?? "" }
                        </TableCell>
                        <TableCell sx={{minWidth: '130px'}}><FormControl fullWidth variant="outlined" size="small">
                           <TextField
                              id="outlined-number"
                              label="Km"
                              type="number"
                              size="small"
                              onChange={(e) => handleChangeKm(e, index)}
                              value={dest?.distance_km ?? ""}
                              disabled={dest?.transport_type === 'AVION'}
                              InputProps={{ inputProps: { min: 0 } }}
                            />
                          </FormControl>
                         </TableCell>
                        <TableCell sx={{ minWidth: '220px'}}>
                        <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={transportMeans}
                              getOptionLabel={(option) => option.label}
                              size="small"
                                sx={{
                                "& .MuiAutocomplete-option": {
                                  fontSize: "13px",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "13px",
                                    },
                                  }}
                                />
                              )}
                              value={
                                transportMeans.find(
                                  (t) => dest.mission_rent_id
                                    ? String(t.mission_rent_id) === String(dest.mission_rent_id)
                                    : t.value === dest.transport_type
                                ) || null
                              }
                              onChange={(_, newValue) => {
                                if (newValue?.value === 'AVION') {
                                  handleChangeFormValues('distance_km', 0, index);
                                }
                                handleChangeFormValues('transport_type', newValue ? newValue : {}, index);
                              }}
                            />

                        </TableCell>
                        <TableCell sx={{textAlign: "center"}} className={classes.tdBordered}>
                           <label>{ dest?.mission_rent_id !== null ?
                          formatWithThousandSeparator(dest?.mission_timesheet_details_consumption, { fallback: '' }) : null }</label>
                        </TableCell>
                        <TableCell sx={{textAlign: "center"}}>
                          <label>{ dest?.mission_rent_id !== null ?
                          formatWithThousandSeparator(rentUpfuel, { fallback: '' })
                          : null }</label>
                        </TableCell>
                        <TableCell sx={{textAlign: "center"}} >
                            { dest?.mission_rent_id !== null ?  formatWithThousandSeparator(dest?.mission_timesheet_details_amount, { fallback: '' }) : null }
                        </TableCell>
                        <TableCell sx={{textAlign: "center"}}>
                          <label>{dest?.mission_rent_id && dest?.mission_rent_id !== null ? "Prix Location" : null}</label>
                        </TableCell>

                        <TableCell sx={{textAlign: "center"}}>
                          {rentPaymentLabel ? (
                            <Box>
                              <label style={{color: "green"}}>{rentPaymentLabel}</label>
                            </Box>
                          ) : null}
                          </TableCell>
                           <TableCell sx={{ minWidth: '120px', textAlign: "center"}}>
                          {dest?.mission_rent_id && dest?.mission_rent_id !== null ? (
                            <Box>
                              <label>{formatWithThousandSeparator(rentAmountToDisplay, { fallback: '' })}</label>
                              {/* si le mode de paiement est forfaitaire afficher le montant global */}
                              {isRepeatedFlatRent ? (
                                <Box sx={{ fontSize: '11px', color: '#5f6b7a', lineHeight: 1.25, mt: 0.5, fontStyle: 'italic' }}>
                                  {`Montant global : ${rentDisplayName}`}
                                </Box>
                              ) : null}
                            </Box>
                          ) : null}
                        </TableCell>
                        <TableCell sx={{minWidth: "100px", textAlign: "center"}} className={classes.tdBordered}>
                          <TextField
                            type="number"
                            size="small"
                            value={dest?.night_number ?? 0}
                            disabled={!canEditNightNumber || isLoadingData}
                            onChange={(event) => handleChangeNightNumber(event.target.value, index)}
                            onFocus={(event) => event.target.select()}
                            onBlur={() => handleBlurNightNumber(index)}
                            inputProps={{ min: 0, step: 1 }}
                            sx={{
                              minWidth: '80px',
                              '& input': {
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: 'purple',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{width: '400px'}} className={classes.tdBordered}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={dest?.observation || ""}
                            multiline
                            placeholder='votre observation ici ...'
                            rows={2}
                            sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "13px",
                                    },
                                  }}
                            onChange={(e) => handleChangeFormValues('observation', e.target.value, index)}
                            />
                        </TableCell>
                      </TableRow>
                    );
                    })
                  )}
                  </TableBody>
                           </Table>
                          </TableContainer>
                          </TabPanel>

                          {/* gestion des locations */}
                      <TabPanel value="2">
                          <RentManagement setMessage={setMessage} setValue={setValue} setTransportMeans={setTransportMeans} mission_planning_agenda_id={agenda_id} />
                        </TabPanel>
                          </TabContext>
                  </fieldset>
                        ))) : (
                          <Alert severity="info" size="small" sx={{ marginTop: "1%", fontSize: "12px" }}>
                          Aucun agenda n'est associé à cette mission.
                      </Alert>
                        )
                      }
        </DialogContentText>

                </DialogContent>
                <DialogActions>
             <Box container item xs={6} spacing={2} display="flex" justifyContent="" sx={{ marginTop: "5px", marginBottom: "5px" }}>
                           <span style={{color: "red", marginRight: "24vw", fontSize: "13px"}} ><strong> Veuillez defiler horizontalement le tableau pour voir toutes les colonnes.</strong>
</span>
              </Box>
             <Box container item xs={6} spacing={2} display="flex" justifyContent="flex-end" sx={{ marginTop: "5px", marginBottom: "5px" }}>
                     <Button variant="contained"
                                    color="error"
                                    size="medium"
                                    style={{ marginRight: '30px', }}
                                    onClick={() => navigate("/mission/timesheet")}
                                    autoFocus
                                  >
                                    Annuler
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="info"
                                    size="medium"
                                    style={{ marginRight: '30px' }}
                                    onClick={() => handleSave('save')}
                                    autoFocus
                                    disabled={isLoadingData}
                                  >
                                    Enregistrer
                                  </Button>
                                   <Button
                                                  variant="contained"
                                                  color="info"
                                                  size="medium"
                                                  style={{ marginRight: '30px' }}
                                                  onClick={() => handleSave('send')}
                                                  autoFocus
                                                  disabled={isLoadingData}
                                                  startIcon={<SendIcon />}
                                                >
                                                  Enregistrer et envoyer
                                                </Button>
                                  </Box>
                </DialogActions>
            </Dialog>


              <DestinationAddDialog destDialog={destDialog} setDestDialog={setDestDialog} setMessage={setMessage} fetchDestinations={fetchDestinations} onAddDestination={handleAddDestination} />
           {/* // Dialog de confirmation de suppression d'une destination */}
           <RemoveDestinationDialog removeDialog={removeDialog} setRemoveDialog={setRemoveDialog} setMessage={setMessage} setOpenLoadingSimpleBackdrop={setLoadingBackdrop}
           setDestinations={setDestinations} fetchDestinations={fetchDestinations} />
           <DestinationViewDialog open={viewDialog.open} destination={viewDialog.destination} onClose={handleCloseDestinationView} editable={viewDialog.editable} onSave={handleSaveDestinationEdit} setDestinations={setDestinationsWithNightDistribution} setMessage={setMessage} missionTimesheetId={currentTimesheetId}/>
           <TimesheetSend confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} setMessage={setMessage} />

       </MainContainer>
    );
}
export default TimesheetAdd;
